import Scrollhistorie from '@nrk/dh-basis-scrollhistorie'

/* styles */
import styles from './forklaringsscroll.css'

export default class Forklaringsscroll extends Scrollhistorie {
  connectedCallback() {
    super.connectedCallback()
    requestAnimationFrame(this.updateMarginAndHeights)
    window.addEventListener('resize', this.updateMarginAndHeights)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('resize', this.updateMarginAndHeights)
  }

  measureICBHeight() {
    /*
     * Measure the height of the Initial Containing Block (ICB).
     * In most modern browsers 100vh === height of the ICB.
     * The ICB does not change when the URL bar is hidden.
     * */
    try {
      const element = document.createElement('div')
      element.style.height = 'calc(100 * var(--dh-vh))'
      element.style.position = 'absolute'
      element.style.top = '0'
      element.style.left = '0'
      document.documentElement.appendChild(element)
      const icbHeight = element.offsetHeight
      document.documentElement.removeChild(element)
      return icbHeight
    } catch (e) {
      return window.innerHeight
    }
  }

  updateMarginAndHeights = () => {
    const backgrounds = this.backgrounds
    const triggerElements = this.triggerElements
    if (!backgrounds || !backgrounds.length || !triggerElements || !triggerElements.length) {
      return
    }

    const icbHeight = this.measureICBHeight()
    // Measure first background. All backgrounds should be 3:4
    const { height } = backgrounds[0].getBoundingClientRect()
    const storyMargin = (icbHeight - height) / 2

    const firstCardHeight = triggerElements[0]
      .querySelector('.' + styles.card)
      .getBoundingClientRect().height
    const lastCardHeight = triggerElements[triggerElements.length - 1]
      .querySelector('.' + styles.card)
      .getBoundingClientRect().height

    if (!isNaN(storyMargin)) {
      this.style.setProperty('--sfv-storyMargin', `${storyMargin}px`)
      this.style.setProperty('--sfv-firstCardHeight', `${firstCardHeight}px`)
      this.style.setProperty('--sfv-lastCardHeight', `${lastCardHeight}px`)

      const negativeStoryMargin = `${(-1 * storyMargin).toFixed(1)}px`
      this.rootMargin = `${negativeStoryMargin} 0px ${negativeStoryMargin} 0px`
    }
  }
}
